export const region = 'europe-west3'

export const PRODUCTION_PROJECT_ID = 'leafonlineplatform'
export const STAGING_PROJECT_ID = 'staging-leaf-digital-platform'

export type RuntimeEnvironment = 'production' | 'staging' | 'unknown'
export type SupportedRuntimeEnvironment = Exclude<RuntimeEnvironment, 'unknown'>

export const getRuntimeEnvironmentFromProjectId = (projectId?: string | null): RuntimeEnvironment => {
    const normalizedProjectId = projectId?.trim()

    if (normalizedProjectId === PRODUCTION_PROJECT_ID) {
        return 'production'
    }

    if (normalizedProjectId === STAGING_PROJECT_ID) {
        return 'staging'
    }

    return 'unknown'
}

export const isSupportedRuntimeEnvironment = (
    runtimeEnvironment: RuntimeEnvironment
): runtimeEnvironment is SupportedRuntimeEnvironment => runtimeEnvironment !== 'unknown'

export enum Collections {
    JOB_REQUESTS = 'job-requests',
    JOBS = 'jobs',
    MENTORINGS = 'mentorings',
    MENTORING_GROUPS = 'mentoring-groups',
    NOTIFICATIONS = 'notifications',
    ORGS = 'orgs',
    ORG_TRANSACTIONS = 'org-transactions',
    PROFILES = 'profiles',
    PROJECTS = 'projects',
    SKILLS = 'skills',
    USERS = 'users',
    PARTICIPATION_REQUESTS = 'participation-requests',
    TALENTBASE_REQUESTS = 'talentbase-requests',
    BLOGS = 'blogs',
    INTROS = 'intros',
    SETTINGS = 'settings',
    PROJECT_REQUESTS = 'project_requests',
    PAID_SERVICE_REQUESTS = 'paid-service-requests',
    /** Contact form on the pages for organizations; written by Functions only (B2BController). */
    B2B_CONTACT_REQUESTS = 'b2b-contact-requests',
    /** Which candidates an org opened in full via job poster access (TalentBaseService); Functions only. */
    TALENT_BASE_FULL_PROFILE_VIEWS = 'talentbase-full-profile-views',
    AGREEMENTS = 'agreements',
    CONSENTS = 'consents',
    CHATS = 'chats',
    CACHE = 'cache',
    MEMBERSHIP_REQUESTS = 'membership-requests',
    FEEDBACKS = 'feedbacks',
    COLLECTIONS = 'collections',
    INTERESTS = 'interests',
    COMMUNITIES = 'communities',
    COMMUNITY_CONNECTION_REQUESTS = 'community-connection-requests',
    COMMUNITY_GROUPS = 'community-groups',
    COMMUNITY_FEED_POSTS = 'community-feed-posts',
    EXTERNAL_API = 'external-api',
    EXTERNAL_API_KEYS = 'external-api-keys',
    EXTERNAL_API_ENTITIES = 'external-api-entities',
    EXTERNAL_API_WEBHOOKS = 'external-api-webhooks',
    NOTIFICATION_SUBSCRIPTIONS = 'notification-subscriptions',
    // Server-only (default-deny rules): the token behind the unsubscribe link in daily alert emails.
    NOTIFICATION_SUBSCRIPTION_TOKENS = 'notification-subscription-tokens',
    LINKEDIN_CONNECTIONS = 'linkedin-connections',
    COMMUNITY_SECTIONS = 'community-sections',
    MANUAL_MATCHES = 'manual-matches'
}

export const ATTR_CREATED_AT = 'createdAt'
export const ATTR_UPDATED_AT = 'updatedAt'
export const ATTR_DELETED_AT = 'deletedAt'
export const ATTR_CREATED_BY_ID = 'createdById'
export const ATTR_UPDATED_BY_ID = 'updatedById'

// Global community ID - allows all logged-in users to access feed without membership
export const GLOBAL_COMMUNITY_ID = 'global'
